"use client";

import React from "react";
import { Card } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const ensembleMembers = [{
  name: "Ron Dennis",
  instrument: "Musical Director",
  image: "https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-24-at-2.52.14-PM-2.jpeg?v=fgiqgtki32m"
}, {
  name: "Dana Andrews",
  instrument: "Lead Guitar",
  image: "https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-24-at-2.52.15-PM-2.jpeg?v=z3pm9ohujr"
}, {
  name: "John Farr",
  instrument: "BASS GUITAR",
  image: "https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-24-at-2.52.14-PM-7.jpeg?v=5nrzu2z0j14"
}, {
  name: "Spencer Street",
  instrument: "DRUMS & PERCUSSION",
  image: "https://prime-rhino.10web.cloud/wp-content/uploads/2026/05/WhatsApp-Image-2026-05-24-at-2.52.14-PM-3.jpeg?v=axj90qztpfm"
}];
export default function Members() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="103822" id="meet-the-artists" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 text-center md:text-left flex flex-col md:flex-row md:items-end justify-between gap-6">
          <div>
            <h2 className="font-serif font-light text-4xl md:text-5xl lg:text-7xl text-foreground mb-4 tracking-tight italic">
              The Virtuosos
            </h2>
            <p className="text-muted-foreground text-lg max-w-xl font-sans">
              Discover the elite musicians of Synergy Sound - a collective of Los Angeles' finest performers bringing soulful R&B and timeless classics to life with unparalleled elegance.
            </p>
          </div>
          <div className="hidden md:block w-24 h-px bg-primary rounded-lg opacity-50" />
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {ensembleMembers.map((member, i) => <Card key={i} data-index={i} className="relative h-[400px] md:h-[500px] lg:h-[600px] overflow-hidden group border-0 rounded-lg bg-transparent p-0 cursor-pointer">
              <img src={member.image} alt={member.name} className="absolute inset-0 w-full h-full object-cover grayscale transition-all duration-1000 ease-out group-hover:scale-105 group-hover:grayscale-0" />
              
              <div className="absolute inset-0 bg-primary/10 mix-blend-soft-light opacity-0 group-hover:opacity-100 transition-opacity duration-700 ease-in-out" />
              
              <div className="absolute inset-0 bg-gradient-to-t from-background via-background/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out flex flex-col justify-end p-6 md:p-8">
                
                <div className="transform translate-y-8 group-hover:translate-y-0 transition-transform duration-500 ease-out">
                  <h3 className="font-serif font-light text-2xl md:text-4xl text-primary mb-2 italic">
                    {member.name}
                  </h3>
                  <p className="font-mono text-xs md:text-sm text-foreground tracking-widest uppercase">
                    {member.instrument}
                  </p>
                </div>
                
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}